import Location from '@r6digital/rapidstor-types/react/entities/Location';
import Deal from '@r6digital/rapidstor-types/types/Deal';

/**
 * Currency formatting function
 * @param value
 * @param location
 * @returns <string>
 */
export const formatCurrency = (
    value: number,
    location: Location,
    longForm?: boolean,
    shortForm?: boolean
): string => {
    if (!value) {
        value = 0;
    }
    if (location.rapidstor.showWeeklyRates) {
        if (location.settings.billingDefault === '28DayAnniversary') {
            value = value / 4;
        } else {
            value = value * 12 / 52.143; // 12 months in a year, 52.143 weeks in a year
        }
    }
    const response = Math.abs(value).toLocaleString('en-GB', {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        trailingZeroDisplay: 'stripIfInteger',
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
    });

    let timeFrameString = '';
    if (longForm) {
        timeFrameString = location.rapidstor.showWeeklyRates
            ? ' per week'
            : location.settings.billingDefault === '28DayAnniversary'
            ? ' per 4 weeks'
            : ' per month';
    } else {
        timeFrameString = location.rapidstor.showWeeklyRates
            ? '/wk'
            : location.settings.billingDefault === '28DayAnniversary'
            ? '/4wks'
            : '/mo';
    }

    return `${location.rapidstor.currencySymbol}${response}${
        !shortForm ? timeFrameString : ''
    }`;
};

export const formatDealCustomText = (
    deal: Deal,
    location: Location,
    text: string | undefined
) => {
    text = text?.replace(
        /{{DiscountRate}}/g,
        formatCurrency(deal.rates.discountedRate ?? deal.rates.rate, location)
    );
    text = text?.replace(
        /{{DiscountSaving}}/g,
        formatCurrency(
            (deal.rates.discountedRate ?? deal.rates.rate) - deal.rates.rate,
            location
        ).replace(/-/g, '')
    );
    text = text?.replace(/{{StandardRate}}/g, formatCurrency(deal.rates.rate, location));
    return text;
};
